import { useEffect, useState } from 'react'
import { IOrder } from '../../../../../app/entities/Order'
import styles from '../styles.module.css'
import { fetchData } from '../../../global/utils/fetch'
import { getImagesByOrderVehicleId } from '../../api'
import { DELIVERY_CONFIRMATION_IMAGE_TYPES } from '../../../global/constants/image'
import { Box, Modal } from '@mui/material'

interface DeliveryConfirmationDisplayProps {
  order: IOrder | null
}

interface ImageData {
  url: string
  type: string
}

export default function DeliveryConfirmationDisplay(
  props: DeliveryConfirmationDisplayProps,
) {
  const { order } = props
  const [deliveryConfirmationImage, setDeliveryConfirmationImage] =
    useState<string>('')
  const [modalOpen, setModalOpen] = useState(false)

  useEffect(() => {
    if (order?.orderVehicles && order.orderVehicles.length > 0) {
      fetchDeliveryConfirmationImage(order.orderVehicles[0].objectId)
    }
  }, [order])

  async function fetchDeliveryConfirmationImage(orderVehicleId: string) {
    try {
      const images = await fetchData<ImageData[]>(
        getImagesByOrderVehicleId(orderVehicleId),
      )
      if (images && images.length > 0) {
        const deliveryImage = images.find(
          (img) =>
            img.type ===
            DELIVERY_CONFIRMATION_IMAGE_TYPES.delivery_confirmation,
        )
        if (deliveryImage && deliveryImage.url) {
          setDeliveryConfirmationImage(deliveryImage.url)
        }
      }
    } catch (error) {
      console.error('Error fetching delivery confirmation image:', error)
    }
  }

  function handleOpenModal() {
    setModalOpen(true)
  }

  function handleCloseModal() {
    setModalOpen(false)
  }

  if (!deliveryConfirmationImage) {
    return null
  }

  return (
    <div className={styles.deliveryConfirmationContainer}>
      <div>Delivery Confirmation</div>
      <img
        src={deliveryConfirmationImage}
        alt='Delivery Confirmation'
        className={styles.deliveryConfirmationImage}
        onClick={handleOpenModal}
      />
      <Modal
        open={modalOpen}
        onClose={handleCloseModal}
      >
        <Box className={styles.fullscreenImageModal}>
          <img
            src={deliveryConfirmationImage}
            alt='Delivery Confirmation'
            className={styles.fullscreenImage}
            onClick={handleCloseModal}
          />
        </Box>
      </Modal>
    </div>
  )
}
